import { ContentSection } from "@components/LayoutProvider";
import useAnalytics from "@hooks/useAnalytics";
import fetch from "cross-fetch";
import { useEffect } from "react";
import { useQuery } from "react-query";
import settings from "src/settings";
import styled from "styled-components";
const { API_BACKEND_HOSTNAME } = settings;

const Container = styled.div`
  padding: 0 2rem;
  color: white;
`;

function useRules() {
  return useQuery(
    "rules",
    () =>
      fetch(`${API_BACKEND_HOSTNAME}/api/static-v1/chase/pages/rules.json`, {
        headers: { "content-type": "application/json" },
        method: "GET",
      }).then((res) => res.json()),
    {
      refetchOnWindowFocus: false,
    },
  );
}

function Rules() {
  const { data: rules } = useRules();
  const rulesBody = rules?.body;
  const { trackPage } = useAnalytics();
  useEffect(() => {
    trackPage("rules:index");
  }, [trackPage]);

  return (
    <ContentSection>
      <Container>
        <h1>RULES</h1>
        <div dangerouslySetInnerHTML={{ __html: rulesBody }} />
      </Container>
    </ContentSection>
  );
}

export default Rules;
